export default {
  BusinessPurchaseComponentsPur: {
    time: 'Latest Sync. Time',
    title: 'Purchase Order Account Information',
    code: 'Purchase Order No.',
    automatic: 'Auto Generate',
    supplierCode: 'Supplier',
    type: 'Purchase Type',
    buyerName: 'Purchaser',
    warehouseCode: 'Receiving Warehouse',
    paymentType: 'Payment Method',
    expectedDate: 'Estimated Arrival Time',
    overfillRate: 'Overfill ratio',
    invoiceType: 'Invoice Type',
    packagingFlag: 'Whether it contains packaging',
    shippingFlag: 'Whether free shipping',
    logisticsAmount: 'Shipping cost',
    logisticsBusinessId: 'Logistics Company',
    logisticsNo: 'Logistics Number',
    recipientName: 'Full Name',
    recipientPhone: 'Consignee Mobile Phone',
    recipientAddress: 'Shipping Address',
    detailAddress: 'Detailed Address',
    remark: 'Remark',
    information: 'Product Information',
    addingGoods: 'Add Product',
    POStatus: 'Purchase order status',
    postingDate: 'Order creation date',
    documentDate: 'Order generation date',
    requiredDate: 'Delivery date',
    vendorRefNo: 'Vendor ref No',
    getPONo: 'Get Received Goods Qty',
    fixRecvQty: 'Fix Recv Qty',

    table: {
      picture: 'Product Image',
      supplierName: 'Requested Supplier',
      waitQty: 'Unpurchased Quantity',
      applyCode: 'Purchase Request Number',
      spuCode: 'Product Code',
      spuName: 'Product Name',
      skuCode: 'SKU',
      skuName: 'SKU Name',
      planQty: 'Order Quantity',
      taxUnitPrice: 'The unit price including tax',
      excludingTax: 'Purchase Price Excluding Tax',
      taxRate: 'Tax Rate',
      taxPrice: 'Including Tax Amount',
      supplierSpuCode: 'Supplier Product Code',
      supplierSkuCode: 'Supplier SKU Code',
      storageTypeText: 'Please select inbound type',
      warehouseCodeText: 'Please select receiving warehouse',
      supplierCodeText: 'Please select supplier',
      paymentTypeText: 'Please select a payment method',
      expectedDateText: 'Please select an estimated arrival time',
      planQtyText: 'Please enter document quantity',
      taxUnitPriceText: 'Please enter the unit price including tax',
      taxRateText: 'Please enter a tax rate',
      data: 'Data',
      quotedQty: 'Quoted Qty',
      UnitPrice: 'Unit Price',
      Discount: ' Discount',
      TaxCode: 'Tax Code',
      GrosSprice: 'Gross price after Discount',
      Total: 'Total',
      Warehouse: 'Warehouse',
      Length: 'Length',
      Width: 'Width',
      Height: 'Height',
      Volume: 'Volume',
      VolumeUnit: 'Volume Unit',
      Weight: 'Weight',
      UomCode: 'Uom Code',
      FreightInformation: 'Freight information',
      FreightName: 'Freight Name',
      TaxGroup: 'Tax Group',
      Tax: 'Tax %',
      NetAmount: 'Net Amount',
      DistribMethod: 'Distrib.Method',
      TotalTaxAmount: 'Total Tax Amount',
      GrossAmount: 'Gross Amount',
     },

    dialogText: 'Select supplier',
    msgError: 'Please select inbound product',
    msgBoxText: 'Exceeding purchase request quantity, are you sure to generate a purchase order?',
    msgError2: 'The product already exists, please select again!',
    msgError3: 'Please check if the imported SKU is correct!',
    msgError4: 'Please fill in the complete form content.',
    msgError5: 'Please include the currency unit in the import file.',
    ExportPDF: 'Export PDF',
    ViewPDFeffect: 'View PDF effect',
    confirmText1: 'Quantity Not Yet Received',
    confirmText2: 'Quantity Received in This Shipment',
    exportHint: 'Errors Exist in the Import List, please correct all errors on the import validation page before importing',
    barcodeTip: 'Please confirm if you want to download the SKU label. Once downloaded, it will incur a charge to the customer.'
  }
};
